import React, { ReactElement, useContext } from 'react'

import Heading from '../../Common/Components/Heading'
import Fieldset from '../../Common/Components/Fieldset'
import P from '../../Common/Components/P'
import Checkbox from '../../Common/Components/Checkbox'
import FormRow from '../../Common/Components/FormRow'

import { LanguageContext } from '../../Common/Contexts'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { AbandonedCallAlarm as AbandonedCallAlarmLanguage } from '../../../../i18n'
import { HeadingLevel } from '../../Common/Components/Heading/Heading'
// CSS imports. Commented out because of current build process.
// import './abandonedCallAlarm.scss'

/**
 * Component properties type.
 */
type Props = {
    alarmOnNewAbandoned: boolean
    setAlarmOnNewAbandoned: (checked: boolean) => void
}

/**
 * Abandoned call alarm section in Alarms tab of report configuration modal window.
 *
 * @param alarmOnNewAbandoned Report property.
 * @param setAlarmOnNewAbandoned Setter for corresponding report property.
 */
const AbandonedCallAlarm: React.FC<Props> = ({ alarmOnNewAbandoned, setAlarmOnNewAbandoned }: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('AbandonedCallAlarm')

    return (
        <Fieldset className={'abandoned-call-alarm'}>
            <Heading level={HeadingLevel.ONE}>
                {language.get(AbandonedCallAlarmLanguage.AbandonedCallAlarm_SectionHeader)}
            </Heading>
            <P>{language.get(AbandonedCallAlarmLanguage.AbandonedCallAlarm_SectionPara)}</P>
            <FormRow isInline className={'alarm-on-new-abandoned-call'}>
                <Checkbox
                    onChange={setAlarmOnNewAbandoned}
                    isChecked={alarmOnNewAbandoned}
                    labelLeft={language.get(AbandonedCallAlarmLanguage.AlarmonnewabandonedcallLabel)}
                />
            </FormRow>
        </Fieldset>
    )
}

export default React.memo(AbandonedCallAlarm)
